import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=11a9b3dd"
import script from "@/js/feedback.ts?vue&type=script&lang=ts&external"
export * from "@/js/feedback.ts?vue&type=script&lang=ts&external"
import style0 from "./feedback.vue?vue&type=style&index=0&id=11a9b3dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports